<template>
  <div class="app-link">
    <div class="app-link--left">
      <BtnGoogleplay/>
    </div>
    <div class="app-link--right">
      <BtnAppstore/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BtnGoogleplay from '@/components/atoms/BtnGoogleplay'
import BtnAppstore from '@/components/atoms/BtnAppstore'

export default {
  name: 'AppLink',
  components: {
    mapGetters,
    BtnGoogleplay,
    BtnAppstore
  },
  computed: {
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  },
  created () {
  },
  beforeUpdate () {
  },
  updated () {
  },
  activated () {
  }
}
</script>
<style lang="postcss" scoped>
  @import '../../assets/css/mixins.css';
  @import '../../assets/css/variables.css';

  .app-link {
    width: fit-content;
    width: -moz-fit-content;
    height: 48px;
    margin: auto;
    font-size: 0;
    & div {
      display: inline-block;
    }
    &--left {
      margin-right: 20px;
    }
  }
  @media (--breakPoint) {
    .app-link {
      height: 36px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/molecules/AppLink.vue